import { computed } from "mobx";
import { useMemo } from "react";
import { useDealPortfolioStore, usePipedriveStore } from "..";
import IDeal from "../interfaces/IDeal";
import IDealPortfolio from "../interfaces/IDealPortfolio";

export default function usePortfolioForDeal(dealId: number): IPortfolioForDeal {
    const pipedriveStore = usePipedriveStore();
    const dealPortfolioStore = useDealPortfolioStore();

    return useMemo(() => computed(() => {
        const portfolio = dealPortfolioStore.getPortfolioForDeal(dealId);
        const deals = portfolio?.dealIds
            .map(id => pipedriveStore.deals.find(d => d.id === id))
            .filter((d): d is IDeal => !!d) ?? [];
        return { portfolio, deals };
    }), [dealId, dealPortfolioStore.portfolios, pipedriveStore.deals]).get();
}

interface IPortfolioForDeal {
    portfolio: IDealPortfolio | null;
    deals: IDeal[];
}
